export default __webpack_public_path__ + "static/media/bolsita.fc73f658.png";